import coreStore from "./core-store";

const remoteResource = 'processing/api/v1/definitions';

const store = coreStore.createCoreStore('importDefinition', remoteResource);

store.getters.importDefinitionOptions = (state) => state.importDefinitions.filter(def => def.type == 'FILE_IMPORT')
    .map(def => ({name: def.displayName, id: def.id}))

store.getters.processEventOptions = (state) => state.importDefinitions.filter(def => def.type == 'EVENT_TRIGGER')
  .map(def => ({name: def.displayName, id: def.id}))


export default store;
